import 'antd/dist/antd.css';

import {
  Button,
  Card,
  CascaderSelect,
  DatePicker,
  Dialog,
  Form,
  Message,
  Pagination,
  Table,
} from '@alifd/next';
import { Box } from '@mui/material';
import { Input, Select } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';

import client from '../../../../lib/feathers';
import Barcode from './barcode';
import styles from './index.module.scss';

const { Option } = Select;
const { Item } = Form;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

const PostalRegistrationList = () => {
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const postalRegistration = client.service('postalRegistration');
  const users = client.service('users');
  const categoryMenu = client.service('categoryMenu');
  const [addDialog, setAddDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [editIndex, setEditIndex] = useState('');
  const [household, setHousehold] = useState('');
  const [packagerRegistrationTime, setPackagerRegistrationTime] = useState('');
  const [recipient, setRecipient] = useState('');
  const [vendor, setVendor] = useState('');
  const [logistics, setLogistics] = useState('');
  const [placement, setPlacement] = useState('');
  const [remarks, setRemarks] = useState('');
  const [postalArr, setPostalArr] = useState([]);
  const [findMembersArr, setFindMembersArr] = useState([]);
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [barcodeDisplay, setBarcodeDisplay] = useState('');
  const [barcodeDisplayNew, setBarcodeDisplayNew] = useState('');

  // test
  const [barcodeDialog, setBarcodeDialog] = useState(false);
  const [editBarcodeDialog, setEditBarcodeDialog] = useState(false);

  // category
  const [categorySelect, setCategorySelect] = useState('');
  const [tarUserId, setTarUserId] = useState(''); // 包裹戶號user.name
  const [tarUserObjectId, setTarUserObjectId] = useState(''); // 包裹戶號user._id
  // sort
  const [curDataIndex, setCurDataIndex] = useState('createdTime');
  const [curOrder, setCurOrder] = useState('desc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = postalArr.slice(indexOfFirstPost, indexOfLastPost);
  const [filterObj, setFilterObj] = useState({
    status: { $in: ['已退貨', '退貨中'] },
  });

  const config = {
    background: '#f5f5f5',
    marginTop: '20px',
    marginBottom: '20px',
    width: 1,
  };

  // 廠商
  const [vendorCategoryDataArr, setVendorCategoryDataArr] = useState([]);
  const [logisticsCategoryDataArr, setLogisticsCategoryDataArr] = useState([]);
  // 擺放位置
  const [placementCategoryDataArr, setPlacementCategoryDataArr] = useState([]);
  // 包裹類型
  const [postalTypeDataArr, setPostalTypeDataArr] = useState([]);
  // 找到戶號選單排序
  function householdNumberSort(a, b) {
    return a.householdNumber.localeCompare(b.householdNumber);
  }

  useEffect(() => {
    residentAccountNumbers.find({}).then((result) => {
      setResidentAccountNumbersArr(result.data.sort(householdNumberSort));
    });
  }, [residentAccountNumbers]);

  // 製作戶號選單
  function ParseStringToArrayObject() {
    // 戶號拆解
    const data = residentAccountNumbersArr.map((i) =>
      i.householdNumber.split('-')
    );
    let Stages = [];
    function iter(e, si = 1) {
      const va = e.slice(0, si).join('-');
      if (!Stages.includes(va)) Stages.push(va);
      if (e[si]) iter(e, si + 1);
    }
    data.forEach((e) => {
      iter(e);
    });
    Stages = Stages.sort((a, b) => {
      return a.length - b.length;
    });
    const newStages = {};
    Stages.forEach((e) => {
      // (e.length==1)newStages[e] = [e];
      if (e.indexOf('-') === -1) newStages[e] = [e];
      else {
        const theDashNb = e.indexOf('-');
        // newStages[e.slice(0,1)].push(e);
        newStages[e.slice(0, theDashNb)].push(e);
      }
    });
    const FinalData = [];
    Object.keys(newStages).forEach((e) => {
      // { A:['A','A-1'],B:['B','B-1','B-1-1']...}
      const childrenObj = {};
      newStages[e].forEach((ee) => {
        let tempTarLabel = ee;
        if (ee.indexOf('-') >= 0) {
          const tempArrChild = ee.split('-');
          tempTarLabel = tempArrChild[tempArrChild.length - 1];
        }
        childrenObj[ee] = {
          // 'label': ee.indexOf("-")==-1? ee : ee.slice(ee.length-1,ee.length),
          label: tempTarLabel,
          value: ee,
        };
      });
      newStages[e].forEach((ee) => {
        // 底層開始 => 加入到上一層children
        // if(ee.length>=3){
        if (ee.indexOf('-') !== -1) {
          const tempArrChild = ee.split('-');
          // const ky = ee.slice(0,ee.length-2);
          const ky = tempArrChild.slice(0, tempArrChild.length - 1).join('-');
          if (!childrenObj[ky].children) {
            // 加入到上一層children
            childrenObj[ky].children = [childrenObj[ee]];
          } else {
            childrenObj[ky].children.push(childrenObj[ee]);
            childrenObj[ky].children.sort((a, b) => {
              return a.label - b.label;
            }); // label小－大
          }
        }
      });
      FinalData.push(childrenObj[Object.keys(childrenObj)[0]]); // 只取最上層(第一比obj)(資料已經都加到第一比)
    });
    // console.log(FinalData);
    return FinalData;
  }

  // postalRegistration查詢
  const postalFind = useCallback(
    function (para) {
      return new Promise((resolve, reject) => {
        try {
          postalRegistration.find({ query: para }).then((result) => {
            resolve(result && result.data ? result.data : []);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    [postalRegistration]
  );
  /// postalRegistration新增
  function postalCreate(obj) {
    return new Promise((resolve, reject) => {
      try {
        postalRegistration.create(obj).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  /// postalRegistration更新
  function postalUpdate(id, obj) {
    return new Promise((resolve, reject) => {
      // console.log(id, obj, params)
      postalRegistration
        .patch(id, obj)
        .then((result) => {
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /// postalRegistration刪除
  function postalRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        postalRegistration.remove(id).then((result) => {
          resolve(result);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
  function orderSort(a, b) {
    return a.order < b.order ? 1 : -1;
  }

  const serverDataUpdate = useCallback(
    (dataIndex, order) => {
      const rDataIndex = dataIndex || curDataIndex;
      const rOrder = order || curOrder;
      postalFind({ status: { $in: ['退貨中', '已退貨'] } }).then((result) => {
        console.log(result);
        setPostalArr(
          result.sort((a, b) => {
            return (rOrder === 'asc') === a[rDataIndex] > b[rDataIndex]
              ? 1
              : -1;
          })
        );
      });
    },
    [curDataIndex, curOrder, postalFind]
  );

  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setCurDataIndex(dataIndex);
    setCurOrder(order);
    serverDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    serverDataUpdate();
  }, [serverDataUpdate]);

  // categoryMenu
  const findCategory = useCallback(
    async function () {
      const result = await categoryMenu.find({
        query: { service: 'postalRegistration' },
      });
      return result && result.data ? result.data : [];
    },
    [categoryMenu]
  );

  const serverCategoryDataUpdate = useCallback(
    function () {
      findCategory()
        .then((res) => {
          console.log('==categoryMenu find success:', res);
          setVendorCategoryDataArr(res[0].data);
          setLogisticsCategoryDataArr(res[1].data);
          setPlacementCategoryDataArr(res[2].data);
          setPostalTypeDataArr(res[3].data);
        })
        .catch((error) => {
          console.log('==categoryMenu find fail:', error);
        });
    },
    [findCategory]
  );

  useEffect(() => {
    serverCategoryDataUpdate();
  }, [serverCategoryDataUpdate]);

  return (
    <>
      {/* 掃描條碼 */}
      <Dialog
        hasMask
        className={styles.barcodeDialog}
        visible={barcodeDialog}
        footer={false}
        onClose={() => {
          setBarcodeDialog(false);
        }}
      >
        <Form>
          <BarcodeReader
            onScan={(data) => {
              const regex = /^[\d|a-zA-Z]+$/;
              if (regex.test(data)) {
                setBarcodeDisplay(data);
                Message.success('掃描成功');
                setAddDialog(true);
              } else {
                Message.error('掃描失敗，僅能數字和英文');
                setAddDialog(false);
              }
            }}
            onError={(err) => {
              console.error(err);
            }}
          />
          <Item>
            <Input
              style={{ width: '300px' }}
              placeholder="自行輸入條碼 Enter確認"
              name="barcodeDisplay"
              value={barcodeDisplay}
              onChange={(event) => {
                setBarcodeDisplay(event.target.value);
              }}
              onPressEnter={() => {
                const regex = /^[\d|a-zA-Z]+$/;
                if (regex.test(barcodeDisplay)) {
                  Message.success('掃描成功');
                  setBarcodeDialog(false);
                  setAddDialog(true);
                } else {
                  Message.error('掃描失敗，僅能數字和英文');
                  setAddDialog(false);
                }
              }}
            />
          </Item>

          <br />
          <img
            className={styles.packageImg}
            src="https://i.ibb.co/q05FPsK/Lovepik-com-401547424-express-2.png"
            alt="package"
            type="cover"
            width={400}
            height={300}
          />

          <h1>請掃描包裹/郵件條碼...</h1>
        </Form>
      </Dialog>

      {/* 新增包裹 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addDialog}
        onOk={() => {
          if (!categorySelect) {
            Message.warning('請選擇包裹類型');
            return;
          }
          if (!household) {
            Message.warning('請選擇戶號');
            return;
          }
          if (placement === '') {
            Message.warning('請選擇擺放位置');
            return;
          }
          Swal.fire({
            title: '確定新增此包裹資料?',
            text: '請確認資料無誤!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', '此筆資料已新增', 'success');
              postalCreate({
                createdTime: new Date().getTime(),
                updatedTime: new Date().getTime(),
                packagerRegistrationTime: new Date().getTime(),
                order: postalArr.length,
                barcode: barcodeDisplay,
                packageType: categorySelect,
                household,
                recipient,
                vendor,
                logistics,
                placement,
                remarks,
                status: '退貨中',
                userId: tarUserId,
                userObjectId: tarUserObjectId,
                receiveTime: '待領取',
                residentPhoto: null,
                canvas: null,
              })
                .then((res) => {
                  console.log('==postal create result:', res);
                  setHousehold('');
                  setRecipient('');
                  setBarcodeDisplay('');
                  setVendor('');
                  setLogistics('');
                  setPlacement('');
                  setRemarks('');
                  setCategorySelect('');
                  setTarUserId('');
                  setAddDialog(false);
                  setBarcodeDialog(false);
                  serverDataUpdate();
                })
                .catch((error) => {
                  console.log('==postal create fail:', error);
                });
            }
          });
        }}
        onCancel={() => {
          setHousehold('');
          setRecipient('');
          setBarcodeDisplay('');
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setCategorySelect('');
          setTarUserId('');
          setAddDialog(false);
          setBarcodeDialog(false);
        }}
        onClose={() => {
          setHousehold('');
          setRecipient('');
          setBarcodeDisplay('');
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setCategorySelect('');
          setTarUserId('');
          setAddDialog(false);
          setBarcodeDialog(false);
        }}
      >
        <div>
          {/* <p>顯示條碼:{barcodeDisplay}</p> */}
          <div className={styles.categoryBox}>
            <Item label="包裹類型" required>
              <Select
                style={{ width: 200 }}
                defaultValue="請選擇類型"
                onChange={(value) => {
                  setCategorySelect(value);
                }}
              >
                {postalTypeDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>

            {/* <Item label="資訊" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                defaultValue="請選擇方式"
                onChange={(value) => {
                  setCategoryChildSelect({ value, disabled });
                }}
                disabled={disabled}
              >
                {data
                  ? data.map((item) => {
                      return <Option key={item}>{item}</Option>;
                    })
                  : ''}
              </Select>
            </Item> */}
          </div>
          <div className={styles.categoryBox}>
            <Item label="戶號" required>
              <CascaderSelect
                style={{ width: 200 }}
                defaultValue="請選擇戶號"
                dataSource={ParseStringToArrayObject()}
                onChange={(value) => {
                  setHousehold(value);
                  setRecipient('');
                  users
                    .find({
                      query: {
                        householdNumbers: { $in: [value] },
                        f_password: { $exists: false },
                        expireTime: { $exists: false },
                        // name: { $in: res.data[0].members }
                      },
                    })
                    .then((res) => {
                      console.log('==users find names success:', res.data);
                      // setFindMembersArr(res.data.map((item) => item.name));
                      setFindMembersArr(
                        res.data.map((item) => {
                          return {
                            label: item.name,
                            value: item._id,
                          };
                        })
                      );
                    })
                    .catch((error) => {
                      console.log('==users find names fail:', error);
                    });
                }}
              />
            </Item>

            <Item label="收件人" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                value={recipient || '請選擇收件人'}
                onChange={(value, option) => {
                  if (!option.key || option.key.length < 10) {
                    Swal.fire(
                      '錯誤!',
                      '該使用者資訊錯誤,可能已被刪除',
                      'warning'
                    );
                  } else {
                    setTarUserObjectId(option.key);
                    setRecipient(value);
                    setTarUserId(value);
                  }
                }}
              >
                {findMembersArr.map((item) => {
                  return (
                    <Option key={item.value} value={item.label}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>
            </Item>
          </div>
          <Item label="擺放位置" required>
            <Select
              style={{ width: 200 }}
              defaultValue="請選擇擺放位置"
              showSearch
              allowClear
              onChange={(value) => {
                setPlacement(value);
              }}
            >
              {placementCategoryDataArr.map((item) => {
                return <Option key={item}>{item}</Option>;
              })}
            </Select>
          </Item>
          <div className={styles.categoryBox}>
            <Item label="廠商">
              <Select
                style={{ width: 200 }}
                defaultValue="請選擇廠商"
                showSearch
                allowClear
                onChange={(value) => {
                  setVendor(value);
                }}
              >
                {vendorCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
            <Item label="物流" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                defaultValue="請選擇物流"
                showSearch
                allowClear
                onChange={(value) => {
                  setLogistics(value);
                }}
              >
                {logisticsCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="備註">
              <TextArea
                name="remarks"
                maxLength={30}
                placeholder="可用30字元"
                rows={2}
                showCount
                aria-label="input max length 30"
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </Item>
          </div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                alignItems: 'center',
              }}
            >
              <Input
                // label="Enter value here"
                value={barcodeDisplay}
                // onChange={e => setBarcodeValue(e.target.value)}
                margin="normal"
                style={{ width: '50%' }}
                placeholder="請按掃描條碼"
                disabled
              />
              <Button onClick={() => setBarcodeDialog(true)}>掃描條碼</Button>
            </Box>
            <Barcode
              value={barcodeDisplay}
              {...config}
              onResult={(result) => {
                if (!result) {
                  Message.error('禁止中文輸入，請切換英文輸入');
                  setAddDialog(false);
                  setBarcodeDisplay('');
                  setBarcodeDialog(true);
                }
              }}
            />
          </Box>
          {/* <div>
            <BarcodeReader

              onScan={(data) => {
                setBarcodeDisplay(data)
                console.log(data)
              }}
              onError={(err) => {
                console.error(err)
              }}
            />
            <p>顯示條碼:{barcodeDisplay}</p>
          </div> */}
        </div>
      </Dialog>

      {/* 編輯包裹  */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editDialog}
        onOk={() => {
          const item = currentPosts[editIndex];
          item.packageType = categorySelect;
          item.household = household;
          item.recipient = recipient;
          item.userObjectId = tarUserObjectId;
          item.barcode = barcodeDisplayNew || barcodeDisplay;
          // item.barcodeValue = barcodeValue;
          item.vendor = vendor;
          item.logistics = logistics;
          item.placement = placement;
          item.remarks = remarks;
          item.updatedTime = new Date().getTime();

          Swal.fire({
            title: '確定修改此包裹資料?',
            text: '請確認修改資料!!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#BEBEBE',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire('成功!', '此筆資料已編輯', 'success');
              postalUpdate(item._id, item)
                .then((res) => {
                  console.log('==postal update success:', res);
                  serverDataUpdate();
                  // setCategory('');
                  // setPackageType('');
                  setHousehold('');
                  setRecipient('');
                  setTarUserObjectId('');
                  setBarcodeDisplay('');
                  setBarcodeDisplayNew('');
                  // setBarcodeValue('')
                  setVendor('');
                  setLogistics('');
                  setPlacement('');
                  setRemarks('');
                  setTarUserId('');
                  // setCategorySelect('')
                  setEditDialog(false);
                })
                .catch((error) => {
                  console.log('==postal update fail:', error);
                  Message.error(`${error}`);
                });
            }
          });
        }}
        onCancel={() => {
          setHousehold('');
          setRecipient('');
          setTarUserObjectId('');
          setBarcodeDisplay('');
          setBarcodeDisplayNew('');
          // setBarcodeValue('')
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setTarUserId('');
          setEditDialog(false);
        }}
        onClose={() => {
          setHousehold('');
          setRecipient('');
          setTarUserObjectId('');
          setBarcodeDisplay('');
          setBarcodeDisplayNew('');
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setTarUserId('');
          setEditDialog(false);
        }}
      >
        <div>
          <div className={styles.categoryBox}>
            <Item label="包裹類型">
              <Select
                style={{ width: 200 }}
                placeholder="請選擇類型"
                defaultValue={categorySelect}
                onChange={(value) => {
                  setCategorySelect(value);
                }}
              >
                {postalTypeDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="戶號" required>
              <CascaderSelect
                style={{ width: 200 }}
                placeholder="請選擇戶號"
                value={household}
                dataSource={ParseStringToArrayObject()}
                onChange={(value) => {
                  // console.log(value, data, extra)
                  setHousehold(value);
                  setRecipient('');
                  setTarUserObjectId('');
                  users
                    .find({
                      query: {
                        householdNumbers: { $in: [value] },
                        f_password: { $exists: false },
                        expireTime: { $exists: false },
                        // name: { $in: res.data[0].members }
                      },
                    })
                    .then((res) => {
                      console.log('==users find names success:', res.data);
                      // setFindMembersArr(res.data.map((item) => item.name));
                      setFindMembersArr(
                        res.data.map((item) => {
                          return {
                            label: item.name,
                            value: item._id,
                          };
                        })
                      );
                    })
                    .catch((error) => {
                      console.log('==users find names fail:', error);
                    });
                }}
              />
            </Item>
            <Item label="收件人" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                value={recipient || '請選擇收件人'}
                onChange={(value, option) => {
                  if (!option.key || option.key.length < 10) {
                    Swal.fire(
                      '錯誤!',
                      '該使用者資訊錯誤,可能已被刪除',
                      'warning'
                    );
                  } else {
                    setTarUserObjectId(option.key);
                    setRecipient(value);
                    setTarUserId(value);
                  }
                }}
              >
                {findMembersArr.map((item) => {
                  return (
                    <Option key={item.value} value={item.label}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="擺放位置" required>
              <Select
                style={{ width: 200 }}
                placeholder="擺放位置"
                value={placement}
                showSearch
                allowClear
                onChange={(value) => {
                  setPlacement(value);
                }}
              >
                {placementCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="廠商">
              <Select
                style={{ width: 200 }}
                placeholder="請選擇廠商"
                showSearch
                allowClear
                value={vendor === '' ? '無資料' : vendor}
                onChange={(value) => {
                  setVendor(value);
                }}
              >
                {vendorCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
            <Item label="物流" className={styles.categoryItem}>
              <Select
                style={{ width: 200 }}
                placeholder="請選擇物流"
                value={logistics === '' ? '無資料' : logistics}
                showSearch
                allowClear
                onChange={(value) => {
                  setLogistics(value);
                }}
              >
                {logisticsCategoryDataArr.map((item) => {
                  return <Option key={item}>{item}</Option>;
                })}
              </Select>
            </Item>
          </div>
          <div className={styles.categoryBox}>
            <Item label="備註">
              <TextArea
                name="remarks"
                maxLength={30}
                value={remarks}
                placeholder="可用30字元"
                rows={2}
                showCount
                aria-label="input max length 30"
                onChange={(e) => {
                  setRemarks(e.target.value);
                }}
              />
            </Item>
          </div>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            <Input
              label="原有條碼"
              value={barcodeDisplay}
              style={{
                width: '50%',
              }}
            />
            <div>
              <Button
                onClick={() => {
                  setEditBarcodeDialog(true);
                }}
              >
                更改條碼
              </Button>
              <Dialog
                hasMask
                className={styles.barcodeDialog}
                visible={editBarcodeDialog}
                footer={false}
                onClose={() => {
                  setEditBarcodeDialog(false);
                  setBarcodeDisplayNew('');
                }}
              >
                <div>
                  <BarcodeReader
                    onScan={(data) => {
                      setBarcodeDisplayNew(data);
                      console.log(data);
                      // setEditDialog(true)
                      setEditBarcodeDialog(false);
                    }}
                    onError={(err) => {
                      console.error(err);
                    }}
                  />
                  <Input
                    placeholder="自行輸入新條碼 Enter確認"
                    // value={barcodeDisplay}
                    onChange={(event) => {
                      setBarcodeDisplayNew(event.target.value);
                    }}
                    onPressEnter={() => {
                      setEditBarcodeDialog(false);
                    }}
                  />
                  {/* <p>顯示條碼:{barcodeDisplayText}</p> */}
                  <br />
                  <img
                    className={styles.packageImg}
                    src="https://i.ibb.co/q05FPsK/Lovepik-com-401547424-express-2.png"
                    alt="package"
                    type="cover"
                    width={400}
                    height={300}
                  />

                  <h1>請掃描包裹/郵件條碼...</h1>
                </div>
              </Dialog>
            </div>
            <Barcode value={barcodeDisplay} {...config} />
            <br />
            <br />
            <p>更改後條碼:{barcodeDisplayNew}</p>
            <Barcode
              value={barcodeDisplayNew}
              {...config}
              onResult={(result) => {
                if (!result) {
                  Message.error('禁止中文輸入，請切換英文輸入');
                  setEditBarcodeDialog(true);
                }
              }}
            />
          </Box>
        </div>
      </Dialog>

      {/* 查看包裹  */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={previewDialog}
        footerActions={['cancel']}
        onOk={() => {
          setPreviewDialog(false);
        }}
        onCancel={() => {
          setPackagerRegistrationTime('');
          setBarcodeDisplay('');
          setCategorySelect('');
          setHousehold('');
          setRecipient('');
          setTarUserObjectId('');
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setPreviewDialog(false);
        }}
        onClose={() => {
          setPackagerRegistrationTime('');
          setBarcodeDisplay('');
          setCategorySelect('');
          setHousehold('');
          setRecipient('');
          setTarUserObjectId('');
          setVendor('');
          setLogistics('');
          setPlacement('');
          setRemarks('');
          setPreviewDialog(false);
        }}
      >
        <Form>
          <Item label="包裹登記時間">
            <h3>{new Date(packagerRegistrationTime).toLocaleString()}</h3>
          </Item>

          <Item label="包裹類型">
            <h3>{categorySelect}</h3>
          </Item>
          <Item label="戶號">
            <h3>{household}</h3>
          </Item>
          <Item label="收件人">
            <h3>{recipient === '' ? '無資料' : recipient}</h3>
          </Item>
          <Item label="擺放位置">
            <h3>{placement}</h3>
          </Item>
          <Item label="廠商">
            <h3>{vendor === '' ? '無資料' : vendor}</h3>
          </Item>
          <Item label="物流">
            <h3>{logistics === '' ? '無資料' : logistics}</h3>
          </Item>
          <Item label="備註">
            <h3>{remarks === '' ? '無資料' : remarks}</h3>
          </Item>
          <Item label="條碼">
            <h3>
              {barcodeDisplay === '' ? (
                '無資料'
              ) : (
                <Barcode value={barcodeDisplay} {...config} />
              )}
            </h3>
          </Item>
        </Form>
      </Dialog>

      <div className={styles.container}>
        <div className={styles.btnBox}>
          <Button
            className={styles.typeBtn1}
            onClick={() => {
              setAddDialog(true);
            }}
          >
            新增郵務退貨
          </Button>
        </div>
        <div className={styles.btnBox}>
          <div>
            類型：
            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="請選擇類型"
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value) {
                  newFilter = {
                    ...newFilter,
                    packageType: value,
                  };
                } else {
                  delete newFilter.packageType;
                }
                setFilterObj(newFilter);
                const res = await postalRegistration.find({ query: newFilter });
                setPostalArr(res.data);
              }}
            >
              {postalTypeDataArr.map((item) => {
                return <Option key={item}>{item}</Option>;
              })}
            </Select>
          </div>
          <div style={{ marginLeft: 10 }}>
            戶號：
            <CascaderSelect
              placeholder="請選擇"
              hasClear
              style={{ width: 200 }}
              dataSource={ParseStringToArrayObject()}
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value) {
                  newFilter = {
                    ...newFilter,
                    household: value,
                  };
                } else {
                  delete newFilter.household;
                }
                setFilterObj(newFilter);
                const res = await postalRegistration.find({ query: newFilter });
                setPostalArr(res.data);
              }}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            時間：
            <RangePicker
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value.length === 2) {
                  newFilter = {
                    ...newFilter,
                    createdTime: {
                      $gte: moment(value[0]).startOf('day').valueOf(),
                      $lte: moment(value[1]).endOf('day').valueOf(),
                    },
                  };
                } else {
                  delete newFilter.createdTime;
                }
                setFilterObj(newFilter);
                const res = await postalRegistration.find({ query: newFilter });
                setPostalArr(res.data);
              }}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            狀態:
            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="請選擇狀態"
              onChange={async (value) => {
                let newFilter = { ...filterObj };
                if (value) {
                  newFilter = {
                    ...newFilter,
                    status: value,
                  };
                } else {
                  delete newFilter.status;
                  newFilter = {
                    status: { $in: ['已退貨', '退貨中'] },
                  };
                }
                setFilterObj(newFilter);
                const res = await postalRegistration.find({ query: newFilter });
                setPostalArr(res.data);
              }}
            >
              <Option key="退貨中">退貨中</Option>
              <Option key="已退貨">已退貨</Option>;
            </Select>
          </div>
        </div>

        {/* <ReactDragListView onDragEnd={onDragEnd}> */}
        <Card free>
          <Card.Content>
            <Table dataSource={currentPosts} onSort={onTableSort}>
              <Table.Column
                lock="left"
                sortable
                dataIndex="plateNumber"
                title="編號"
                width={100}
              />
              <Table.Column
                sortable
                title="建立時間"
                width={200}
                dataIndex="createdTime"
                cell={(_value, _index, record) => {
                  return (
                    <p>
                      {moment(record.createdTime).format('YYYY-MM-DD HH:mm:ss')}
                    </p>
                  );
                }}
              />
              {/* <Table.Column
          title="更新時間"
          width={100}
          cell={(record, index) => {
            return <p>{new Date(currentPosts[index].updatedTime).toLocaleString()}</p>;
          }}
        /> */}
              {/* <Table.Column title="條碼" dataIndex="barcode" width={200} /> */}
              <Table.Column
                sortable
                title="包裹類型"
                dataIndex="packageType"
                width={200}
              />

              <Table.Column
                sortable
                title="戶號"
                dataIndex="household"
                width={200}
              />
              <Table.Column
                sortable
                title="收件人"
                dataIndex="recipient"
                width={200}
              />

              {/* <Table.Column title="物流" dataIndex="logistics" width={200} /> */}
              <Table.Column
                sortable
                title="擺放位置"
                dataIndex="placement"
                width={200}
              />
              <Table.Column
                sortable
                title="狀態"
                dataIndex="status"
                width={200}
              />
              {/* <Table.Column title="備註" dataIndex="remarks" width={150} /> */}
              <Table.Column
                title="操作"
                width={350}
                lock="right"
                cell={(_value, index, record) => {
                  // console.log('==op ', value, index, record);

                  return (
                    <div className={styles.btn}>
                      <Button
                        type="secondary"
                        onClick={() => {
                          setPackagerRegistrationTime(
                            record.packagerRegistrationTime
                          );
                          setBarcodeDisplay(record.barcode);
                          setCategorySelect(record.packageType);
                          setHousehold(record.household);
                          setRecipient(record.recipient);
                          setTarUserObjectId(record.userObjectId || '');
                          setVendor(record.vendor);
                          setLogistics(record.logistics);
                          setPlacement(record.placement);
                          setRemarks(record.remarks);
                          setPreviewDialog(true);
                        }}
                      >
                        查看
                      </Button>
                      <Button
                        type="normal"
                        onClick={() => {
                          setHousehold(record.household);
                          setRecipient(record.recipient);
                          setTarUserObjectId(record.userObjectId || '');
                          setBarcodeDisplay(record.barcode);
                          // setBarcodeValue(record.barcodeValue);
                          setVendor(record.vendor);
                          setLogistics(record.logistics);
                          setPlacement(record.placement);
                          setRemarks(record.remarks);
                          setEditIndex(index);
                          setEditDialog(true);
                          setCategorySelect(record.packageType);

                          users
                            .find({
                              query: {
                                householdNumbers: { $in: [record.household] },
                                f_password: { $exists: false },
                                expireTime: { $exists: false },
                                // name: { $in: res.data[0].members }
                              },
                            })
                            .then((res) => {
                              console.log(
                                '==users find names success:',
                                res.data
                              );
                              // setFindMembersArr(res.data.map((item) => item.name));
                              setFindMembersArr(
                                res.data.map((item) => {
                                  return {
                                    label: item.name,
                                    value: item._id,
                                  };
                                })
                              );
                            })
                            .catch((error) => {
                              console.log('==users find names fail:', error);
                            });
                        }}
                      >
                        編輯
                      </Button>

                      <Button
                        type="primary"
                        warning
                        onClick={() => {
                          const item = currentPosts[index];
                          Swal.fire({
                            title: '確定刪除此包裹資料?',
                            text: '刪除後將無法復原!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('刪除!', '此筆資料已刪除', 'success');
                              postalRemove(item._id).then(() => {
                                serverDataUpdate();
                              });
                            }
                          });
                        }}
                      >
                        刪除
                      </Button>
                      {record.status === '退貨中' && (
                        <Button
                          type="primary"
                          onClick={() => {
                            const item = currentPosts[index];
                            Swal.fire({
                              title: '確定已退貨成功?',
                              text: '修改後將無法復原!!',
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#BEBEBE',
                              confirmButtonText: '確定',
                              cancelButtonText: '取消',
                            }).then((result) => {
                              if (result.isConfirmed) {
                                Swal.fire(
                                  '成功!',
                                  '此筆資料已修改成功',
                                  'success'
                                );
                                postalUpdate(item._id, {
                                  ...item,
                                  status: '已退貨',
                                  receiveTime: moment().format(
                                    'YYYY-MM-DD HH:mm:ss'
                                  ),
                                }).then(() => {
                                  serverDataUpdate();
                                });
                                if (item.recipient === '') {
                                  // 20220318 新增寄物通知推播
                                  axios('/ezcon/api/emitMsgQuery', {
                                    method: 'POST',
                                    headers: {
                                      authorization:
                                        window.localStorage['feathers-jwt'],
                                    },
                                    data: {
                                      service: 'message',
                                      event: 'msg',
                                      title: '郵件包裹退貨通知',
                                      content: `已於${moment().format(
                                        'YYYY/MM/DD HH:mm'
                                      )}退貨給廠商`,
                                      type: 'success',
                                      class: 'postalRegistration',
                                      duration: 8000,
                                      redirect: '/ezpro/postal/postalFrontDesk',
                                      query: {
                                        householdNumbers: {
                                          $in: [item.household],
                                        },
                                        firebaseClass: '郵件包裹',
                                      },
                                    },
                                  })
                                    .then((res) => {
                                      console.log(
                                        '==send message Success:',
                                        res
                                      );
                                      Message.success('已傳送推播給住戶');
                                    })
                                    .catch((error) => {
                                      console.error(
                                        '==send message fail:',
                                        error
                                      );
                                    });
                                } else {
                                  axios('/ezcon/api/emitMsgQuery', {
                                    method: 'POST',
                                    headers: {
                                      authorization:
                                        window.localStorage['feathers-jwt'],
                                    },
                                    data: {
                                      service: 'message',
                                      event: 'msg',
                                      title: '郵件包裹退貨通知',
                                      content: `已於${moment().format(
                                        'YYYY/MM/DD HH:mm'
                                      )}退貨給廠商`,
                                      type: 'success',
                                      class: 'postalRegistration',
                                      duration: 8000,
                                      redirect: '/ezpro/postal/postalFrontDesk',
                                      query: {
                                        _id: item.userObjectId,
                                        firebaseClass: '郵件包裹',
                                      },
                                    },
                                  })
                                    .then((res) => {
                                      console.log(
                                        '==send message Success:',
                                        res
                                      );
                                      Message.success('已傳送推播給住戶');
                                    })
                                    .catch((error) => {
                                      console.error(
                                        '==send message fail:',
                                        error
                                      );
                                    });
                                }
                              }
                            });
                          }}
                        >
                          退貨
                        </Button>
                      )}
                    </div>
                  );
                }}
              />
            </Table>
            <Pagination
              className={styles.pagination}
              total={postalArr.length}
              pageSize={postsPerPage}
              totalRender={(total) => `Total: ${total}`}
              onChange={(pageNumber) => {
                setCurrentPage(pageNumber);
              }}
            />
            {/* </ReactDragListView> */}
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default PostalRegistrationList;
